import { FaEye, FaGithub } from "react-icons/fa";

export const Proj9 = () => {
  return (
    <article className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-500 bg-white/5 backdrop-blur-sm mt-4">
      {/* Project Image */}
      <img src="/img/projects/uxs.png" alt="URI Shortener" className="w-full h-64 md:h-72 object-cover rounded-t-2xl" loading="lazy" />

      {/* Project Info */}
      <div className="p-6 space-y-4">
        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">URI Shortener</h3>
        <p className="text-gray-600 text-lg leading-relaxed">My URI Shortener app lets users quickly shorten long URLs into concise, shareable links while tracking analytics like clicks and usage. It provides a simple, efficient way to manage and monitor link performance.</p>

        <div className="flex justify-center gap-4 mt-4">
          <a href="https://uxs.netlify.app/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-5 py-2 rounded-xl font-semibold text-white shadow-md bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:scale-105 transition-transform duration-300" aria-label="View URI Shortener app">
            <FaEye className="mr-2" /> View
          </a>

          <a href="https://github.com/Tsheko777/uxs" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-5 py-2 rounded-xl font-semibold text-white shadow-md bg-gray-800/80 hover:bg-gray-900/90 transition" aria-label="View URI Shortener GitHub repo">
            <FaGithub className="mr-2" /> Code
          </a>
        </div>
      </div>
    </article>
  );
};
